import { apiHelper } from '@/utils/api.helper'
import queryString from 'query-string'

export const WISHLIST = {
  getWishlist,
  addWishlist,
  deleteWishlist
}

const URL = {
  WISHLIST: 'wishlist',
  INDEX: 'index',
  CREATE: 'create',
  DELETE: 'delete'
}

function getWishlist() {
  return apiHelper().get(`${URL.WISHLIST}/${URL.INDEX}`)
}

function addWishlist(form) {
  return apiHelper().post(`${URL.WISHLIST}/${URL.CREATE}`, null, {
    params: form
  })
}

function deleteWishlist(form) {
  console.log('FORM', form)
  return apiHelper().delete(`${URL.WISHLIST}/${URL.DELETE}?wish_id={"wish_id":${encodeURIComponent(JSON.stringify(form))}}`)
}
